import schedule_gen_2 from '@devices/settings/device_settings/schedule_gen_2.js';
import webhooks_gen_2 from '@devices/settings/device_settings/webhooks_gen_2.js';
import scripts_gen_2 from '@devices/settings/device_settings/scripts_gen_2.js';
import networks_gen_2_pro from '@devices/settings/device_settings/networks_gen_2_pro.js';
import virtual_components_pro_devices from '@devices/settings/device_settings/virtual_components_pro_devices.js';
import safety_gen_2_over_under_voltage from '@devices/settings/device_settings/safety_gen_2_over_under_voltage.js';
import app_setting_gen_2 from '@devices/settings/device_settings/app_setting_gen_2.js';
import share from '@devices/settings/device_settings/share.js';
import settings_gen_2_circuit_breaker from '@devices/settings/device_settings/settings_gen_2_circuit_breaker.js';
import bluetooth_gen_2 from '@devices/settings/device_settings/bluetooth_gen_2.js';

export default {
	name: 'ShellyPro1CB',
	friendly_name: 'Pro 1 CB',
	family: 'breaker',
	isPM: false,
	modes: {
		breaker: {
			availableViews: ['basic'],
			channels: 1,
			notifications: [
				'offline',
				'device_problem',
				'overpower',
				'overvoltage',
				'forgotten_lights',
				'overtemperature',
			],
			settings: [
				schedule_gen_2,
				webhooks_gen_2,
				scripts_gen_2,
				networks_gen_2_pro,
				bluetooth_gen_2,
				virtual_components_pro_devices,
				safety_gen_2_over_under_voltage,
				app_setting_gen_2,
				share,
				settings_gen_2_circuit_breaker,
			],
		},
	},
};
